import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {attachWorkspaceFilterState, readTypeAheadUnitState, restoreTypeAheadUnitState, resolveUnitByCode} from '../../utils/workspaceStateUtil.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {BaseComponent} from '../basecomponent.js';
import {DataTools} from './dataTools.js';


/* global customElements */
class DistanceSummaryContainer extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var distanceSummaryContainer = this;
		setTimeout(function(){
			distanceSummaryContainer.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var distanceSummaryContainer = this;
		
		var lookupRequestId = 0;
		var loadReferenceLookup = function (refType, lookupValue, selectedUnitId) {
			var requestId = ++lookupRequestId;
			var paging = {
				max: 100
			};
			if (lookupValue) {
				paging.filterField = 'description';
				paging.filterValue = lookupValue;
			}

			return UnitService.getUnitLookupService().getUnits(refType, paging).then(function (units) {
				if (requestId !== lookupRequestId) {
					return;
				}

				units.data = units.data || [];

				var unitField = ElementUtil.query(toolbarFilter, 'filterTractorId');
				var applyItems = function(items) {
					if (requestId !== lookupRequestId) {
						return;
					}
					unitField.items = items;
					if (selectedUnitId) {
						unitField.value = selectedUnitId;
					}
				};

				if (selectedUnitId) {
					var found = units.data.some(function(unit) {
						return unit.code === selectedUnitId;
					});
					if (!found) {
						return UnitService.getUnitLookupService().getUnits(refType, {
							max: 1,
							filterField: 'code',
							filterValue: selectedUnitId
						}).then(function(matched) {
							if (matched && matched.data && matched.data.length) {
								units.data = matched.data.concat(units.data);
							}
							applyItems(units.data);
						});
					}
				}
				applyItems(units.data);
			});
		};		
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [											
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterTractorId',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Tractor',
					'item-value-path': 'code',
					'item-label-path': 'description',								
					postinit: function(combo) {																	
					},
					placeHolder: 'Select',
					listeners: {
						input: {
							fn: function(e) {
								loadReferenceLookup('TRACTOR', e.target.value);	
							},
							buffer: 500
						},
						change: function() {
							actionRefresh();
						}
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',
					label: 'Status',
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}					
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterStartDate',
					label: 'Start Date',												
					name: 'filterStartDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.startPreviousMonth());	
					}()
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterEndDate',
					label: 'End Date',												
					name: 'filterEndDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.endPreviousMonth());	
					}()
				}				
			]
		});
		
		var distanceGrid = ElementUtil.create({
			tag: 'dl-distance-summary-grid'
		});
		
		var tripsheetGrid = ElementUtil.create({
			tag: 'dl-tripsheet-grid',
			listeners: {
				'complete' : function() {
					actionRefresh();
				}
			}
		});
		
		var distanceGridConfig = {
			'tab-title': 'Summaries',
			tag: 'div',
			style: 'height: 100%;',
			children: [
				distanceGrid
			]
		};
		
		var tripSheetConfig = {
			'tab-title': '<vaadin-icon icon="vaadin:modal-list"></vaadin-icon> Trip Sheets',
			tag: 'div',
			style: 'height: 100%;',
			children: [
				tripsheetGrid
			]
		};
		
		var tabPanel = ElementUtil.create({
			tag: 'dl-tabpanel',
			slot: 'primary',
			listeners: {
				ready: function() {
					tabPanel.addTabs([
						distanceGridConfig,
						tripSheetConfig
					]);
				}
			}
		});			
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarFilter,
				tabPanel
			]
		});		
		distanceSummaryContainer.append(flexLayout);			
		
		loadReferenceLookup('TRACTOR', null);	
		
		var actionRefresh = function() {
			actionRefreshSummaries();
			actionRefreshTripSheets();			
		};
		
		var actionRefreshSummaries = function() {
			distanceGrid.refreshGrid();
		};
		
		var actionRefreshTripSheets = function() {
			tripsheetGrid.refreshGrid();
		};
		
		distanceGrid.setFilterContainer(toolbarFilter);
		tripsheetGrid.setFilterContainer(toolbarFilter);
		attachWorkspaceFilterState(distanceSummaryContainer, toolbarFilter,
			['filterTractorId','status','filterStartDate','filterEndDate'],
			actionRefresh,
			{
				save: function(state) {
					var unitState = readTypeAheadUnitState(ElementUtil.query(toolbarFilter, 'filterTractorId'));
					state.filterTractorId = unitState.value;
					state.filterTractorDescription = unitState.description;
				},
				restore: function(data) {
					if (data.status !== undefined && data.status !== null) {
						ElementUtil.query(toolbarFilter, 'status').value = data.status;
					}
					if (data.filterStartDate !== undefined && data.filterStartDate !== null) {
						ElementUtil.query(toolbarFilter, 'filterStartDate').value = data.filterStartDate;
					}
					if (data.filterEndDate !== undefined && data.filterEndDate !== null) {
						ElementUtil.query(toolbarFilter, 'filterEndDate').value = data.filterEndDate;
					}
					restoreTypeAheadUnitState({
						combo: ElementUtil.query(toolbarFilter, 'filterTractorId'),
						refType: 'TRACTOR',
						unitId: data.filterTractorId,
						description: data.filterTractorDescription,
						loadLookup: loadReferenceLookup,
						resolveByCode: function(type, unitId) {
							return resolveUnitByCode(function(referenceType, paging) {
								return UnitService.getUnitLookupService().getUnits(referenceType, paging);
							}, type, unitId);
						}
					}).then(function() {
						actionRefresh();
					});
				}
			});
		setTimeout(function(){
			actionRefresh();		
		}, 200);		
	}

}
customElements.define('dl-distance-summary-container', DistanceSummaryContainer);